import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { PokeverseIconAnimated } from './icons/PokeverseIcon';
import { HomeIconAnimated, CollectionIconAnimated, CommunityIconAnimated, MenuIconAnimated } from './icons/NavIcons';

interface BottomNavProps {
  onMenuClick: () => void;
}

export default function BottomNav({ onMenuClick }: BottomNavProps) {
  const location = useLocation();
  const navigate = useNavigate();

  // Scroll to search bar logic
  const handleSearchClick = () => {
    if (location.pathname === '/') {
      const el = document.getElementById('main-search');
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
      navigate('/', { state: { scrollToSearch: true } });
    }
  };

  React.useEffect(() => {
    if (location.pathname === '/' && (location.state as any)?.scrollToSearch) {
      const el = document.getElementById('main-search');
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      // Optionally clear the state after scroll
      window.history.replaceState({}, document.title);
    }
  }, [location]);

  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-[70] bg-black border-t border-white/10 flex justify-around items-center h-16 shadow-xl">
      <Link
        to="/"
        className={`flex flex-col items-center justify-center flex-1 h-full text-xs transition-colors ${location.pathname === '/' ? 'text-white' : 'text-white/60 hover:text-white'}`}
      >
        <HomeIconAnimated size={22} className="mb-1" />
        <span>Home</span>
      </Link>
      <Link
        to="/pokeverse/"
        className={`flex flex-col items-center justify-center flex-1 h-full text-xs transition-colors ${location.pathname === '/pokeverse' ? 'text-white' : 'text-white/60 hover:text-white'}`}
      >
        <PokeverseIconAnimated size={22} className="mb-1" />
        <span>Pokéverse</span>
      </Link>
      <Link
        to="/collection/"
        className={`flex flex-col items-center justify-center flex-1 h-full text-xs transition-colors ${location.pathname === '/collection' ? 'text-white' : 'text-white/60 hover:text-white'}`}
      >
        <CollectionIconAnimated size={22} className="mb-1" />
        <span>Collection</span>
      </Link>
      <Link
        to="/community-sentiment/"
        className={`flex flex-col items-center justify-center flex-1 h-full text-xs transition-colors ${location.pathname === '/community-sentiment' ? 'text-white' : 'text-white/60 hover:text-white'}`}
      >
        <CommunityIconAnimated size={22} className="mb-1" />
        <span>Community</span>
      </Link>
      <button
        onClick={onMenuClick}
        className="flex flex-col items-center justify-center flex-1 h-full text-xs text-white/60 hover:text-white transition-colors focus:outline-none"
        aria-label="Open menu"
      >
        <MenuIconAnimated size={22} className="mb-1" />
        <span>Menu</span>
      </button>
    </nav>
  );
} 